import { UserGenderEnum } from '../enums/user.enums';

export const pathToPrivacyPolicyVersion = '/data-privacy_v1.0.0.json';

export const genderOptions: { value: UserGenderEnum; label: string }[] = [
  {
    value: UserGenderEnum.DIVERS,
    label: 'divers',
  },
  {
    value: UserGenderEnum.MALE,
    label: 'männlich',
  },
  {
    value: UserGenderEnum.FEMALE,
    label: 'weiblich',
  },
];
